import { apis } from 'ui-common'

export default {
  getComplaints: () => apis.$get('/complaints')
}
